export default __webpack_public_path__ + "static/media/Screenshot (1145).83f5f091.png";